import { render, staticRenderFns } from "./areaWorkForm.vue?vue&type=template&id=1df2e68e&"
import script from "./areaWorkForm.vue?vue&type=script&lang=js&"
export * from "./areaWorkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports